import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {Carousel} from 'react-bootstrap'
import Card from '@mui/material/Card';
import {Link} from 'react-router-dom';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import '../pages/pagesStyles.css';

import {RiMailFill} from "react-icons/ri";
import {RiLinkedinBoxFill} from "react-icons/ri";
import headshot from "../images/Headshot.jpg";

import Slide1 from "../images/slide1.png";
import Slide3 from "../images/slide3.jpg";
import Aboutmeslidecover from "../images/aboutmecover.jpg";
import { ReactComponent as linkedIn } from '../images/linkedinSvg.svg';
import { ListItemAvatar } from '@mui/material';
const HeroSlider = () => {
    return (
        <>
        
            <Carousel  className='carousel' fade>
                
                <Carousel.Item interval={1000}  className='item1' >
                    
                    <img
                        className="d-block w-100"
                        src={Slide1}
                        alt="First slide"
                        

                    />
                    
                    <Carousel.Caption className='caption1'>
                        <p className='caption1' ><a href="https://www.linkedin.com/in/davis-
kajuna-028b5b168/" target="_blank"><RiLinkedinBoxFill className='linkedinIcon' style={{height:"10%", width:"8%", marginBottom:"14.5%", marginRight:"1%"}}/></a> </p>
                        
                    </Carousel.Caption>
                    
                </Carousel.Item>
                
                <Carousel.Item interval={500}>
                        <img
                        className="d-block w-100"
                        src={Aboutmeslidecover}
                        alt="First slide"
                        />

                    <Carousel.Caption>
                        <h5 style={{fontStyle:"oblique"}} className='caption2'>Hello, my name is Davis Kajuna and I am a data scientist with 2 years of experience, currently looking for a mew job<br/>
                        In my previous role, I was a data scientist at a consulting company<br/>
                        </h5>
                        <ListItemAvatar ><img className='headshot' src={headshot} height="200px" width="200px" style={{borderRadius: "50%"}}></img></ListItemAvatar>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={Slide3}
                        alt="Third slide"
                    />
                    <Carousel.Caption>
                        <h5 style={{fontStyle:"oblique"}} className='caption3'>Projects can be found in the projects tab. All projects have links to both, <b/>
                        their web apps and their github repository. </h5>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </>
    )
}

export default HeroSlider